export default "__VITE_ASSET__LvPqR9zafrtYtBG$CdltiA__"